import { CSSObject, styled, Theme } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';

export const DRAWER_WIDTH = 256; // 16rem = 256px
export const DRAWER_WIDTH_COLLAPSED = 64; // 4rem = 64px

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH_COLLAPSED,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
});

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open ? openedMixin(theme) : closedMixin(theme)),
  '& .MuiDrawer-paper': {
    backgroundColor: '#000848',
    color: 'white',
    overflowY: 'auto',
    ...(open ? openedMixin(theme) : closedMixin(theme)),
    '& .visible-collapsed': {
      display: open ? 'none' : 'inline-block',
    },
    '& .hidden-collapsed': {
      display: open ? 'block' : 'none',
    },
  },
}));
